import jQuery from 'jquery';

export function initializeLogin() {
    const $ = jQuery;

    // #リンク
    $('a[href^="#"]').click(function (e) {
        e.preventDefault();
    });

    // show password
    $('.p-bloc').find('.eye-btn a').click(function (e) {
        $(this).toggleClass('is-show');
        var input = $(this).parent().siblings('input');
        if (input.attr('type') === 'password') {
            input.attr('type', 'text');
        } else {
            input.attr('type', 'password');
        }
    });

    $('.p-register dl.birth input').blur(datepickerReplace);
}

function datepickerReplace(e) {
    const _this = e.target;
    const today = new Date();
    const splitString = _this.value.split('');
    const hasSymbol = splitString.some(string => string === '/' || string === '-');
    const replaceString = splitString.map(string => string === '/' ? '-' : string).join('');

    if (splitString.length === 10) {
        _this.value = new Date(replaceString).toString() === 'Invalid Date' ? today : replaceString;
    } else if (splitString.length === 8 && !hasSymbol) {
        const year = replaceString.slice(0, 4);
        const month = replaceString.slice(4, 6);
        const day = replaceString.slice(6);
        const ymd = `${year}-${month}-${day}`;
        _this.value = new Date(ymd).toString() === 'Invalid Date' ? today : ymd;
    } else {
        // other
        _this.value = '';
    }
}
